import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'

import { faGlobe } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Columns, DashboardModule, LoadingModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import { generateUrls } from '@hooks/useService'
import useServices from '@hooks/useServices'

import ListBlankState from '@components/ListBlankState'
import PageFilterModule from '@components/PageFilterModule'
import PageHeader from '@components/PageHeader'

import ServiceListItem from '../ServiceListItem'

const buildPageFilterFields = () => {
  const style = { marginBottom: 16 }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Filter by Title or ID',
    },
  ]
}

interface PageContentProps {
  pageFilters: {
    [key: string]: any,
  },
}

const PageContent = (props: PageContentProps) => {
  const { pageFilters } = props

  const servicesPayload = useServices({
    filters: pageFilters,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredServices,
    filteredServicesCount,
    hasFilteredServices,
    loading,
  } = servicesPayload

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      resetFilters,
      updateFilters,
    },
    defaultFilters,
  } = pageContext

  const { servicesIndexUrl } = generateUrls()

  return (
    <>
      <Helmet>
        <title>Services | Realhub</title>
      </Helmet>

      <PageHeader
        activeTabBarItemKey="services"
        tabBarItems={[
          {
            href: servicesIndexUrl,
            icon: faGlobe,
            key: 'services',
            title: 'Services',
          },
        ]}
        title="Services"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            <LoadingModule loading={loading} times={3} />

            {!loading && !hasFilteredServices && <ListBlankState />}

            {!loading && hasFilteredServices && (
              <DashboardModule contentBoxProps={{ flexDirection: 'column' }} title="Services">
                <Box flexDirection="column">
                  {filteredServices.map(service => (
                    <ServiceListItem key={service.id} service={service} />
                  ))}
                </Box>

                <DashboardModule.LoadMoreFooter
                  callbacks={{ loadMore }}
                  canLoadMore={canLoadMore}
                  entityCount={filteredServicesCount}
                  loading={loading}
                />
              </DashboardModule>
            )}
          </Columns.Main>

          <Columns.Sidebar>
            <PageFilterModule
              callbacks={{ resetFilters, updateFilters }}
              defaultFilters={defaultFilters}
              // @ts-expect-error TS2322
              filterFields={buildPageFilterFields()}
              pageFilters={pageFilters}
              title="Filters"
            />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
